var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"options":_vm.chartOptions,"title":_vm.title,"height":_vm.height,"width":_vm.width,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }